import React from 'react';
import { chapterDisplayTitle } from '../assistant/chapterGate';
import { ChapterVisuals, type ChapterPinHandlers } from '../assistant/ChapterTemplates';
import type { CardMessage } from './cards';

/** The visual half of an answer. `compact` under its answer, `full` opened
 *  beside the home's chat; the answer text sits next to it, never inside it.
 *  `action` sits beside the title (open, close). */
export function MessageCard({
  message,
  density,
  pins,
  cardRef,
  footer,
  action,
}: {
  message: CardMessage;
  density: 'compact' | 'full';
  pins?: ChapterPinHandlers;
  cardRef?: React.Ref<HTMLElement>;
  footer?: React.ReactNode;
  action?: React.ReactNode;
}) {
  const card = message.card;
  // The label already names the window ("Last 4 weeks", "14 Sep – 11 Oct");
  // raw dates only when the model gave none.
  const window = card.windowLabel || (card.start && card.end ? `${card.start} – ${card.end}` : '');
  const title = chapterDisplayTitle(card, message.question ?? '');
  if (density === 'compact') {
    return (
      <article className="maitre-card" ref={cardRef}>
        <header className={`maitre-card-head${action ? ' has-action' : ''}`}>
          <div className="maitre-card-heading">
            <h3 className="maitre-card-title">{title}</h3>
            {window ? <p className="maitre-card-window">{window}</p> : null}
          </div>
          {action}
        </header>
        <ChapterVisuals spec={card} pins={pins} compact />
        {footer}
      </article>
    );
  }
  return (
    <article ref={cardRef} className="maitre-chapter" id={`maitre-card-${message.id}`}>
      <header className={`maitre-chapter-head${action ? ' has-action' : ''}`}>
        <div className="maitre-card-heading">
          <h2 className="maitre-chapter-title">{title}</h2>
          {window ? <p className="maitre-chapter-window">{window}</p> : null}
        </div>
        {action}
      </header>
      <div className="maitre-chapter-visuals">
        <ChapterVisuals spec={card} pins={pins} />
      </div>
      {footer}
    </article>
  );
}
